<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{mType == '2' ? '行政采购项目' : '人力资源项目'}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: mType == '2' ? '/admin' : '/human' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/admin/view?id=${query.id}&mType=${mType}` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}项目支出</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <div class="header-info">
        <h1>{{ form.contract_name }}</h1>
        <p style="font-size: 20px; font-weight: 550;">{{ form.manager_name }}</p>
        <p v-if="form.project_start_time != '0000-00-00'">项目时间: {{
          `${form.project_start_time}-${form.project_end_time}` }}</p>
        <p v-if="form.finish_time && form.finish_time != '0000-00-00'">项目完成时间：{{ form.finish_time }}</p>
      </div>
    </div>

    <div class="form myform" v-if="(mType == '2' ? NodeInclude('133') : NodeInclude('171'))">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">子项目信息</div>
        <ul class="anlist">
          <li v-for="(item, index) in sonList" :key="index">
            <div class="abox">
              <el-form-item label="子项目名称：" prop="son_contract_name">
                <el-col :span="12">
                  <el-input placeholder="请输入" maxlength="100" v-model="item.contract_name" clearable
                    :disabled="form.status == '5'" />
                </el-col>
              </el-form-item>
              <el-form-item label="项目起止时间：" prop="son_contract_time">
                <el-col :span="12">
                  <el-date-picker v-model="item.son_contract_time" type="datetimerange" range-separator="--"
                    start-placeholder="项目开始时间" end-placeholder="项目结束时间" style="width:100%;" @blur="sonContractTime(index)"
                    :disabled="form.status == '5'">
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </div>
            <el-button class="abtn" v-if="form.status != '5'" icon="el-icon-minus" @click="removeSon(sonList, index)" circle></el-button>
          </li>
          <el-button type="primary" style="margin: 0 0 15px -5px;" class="addbtn" v-if="form.status != '5'" @click="addSon(sonList)">新增子项目</el-button>
        </ul>
        <el-form-item label="">
          <el-col :span="10">
            <el-button @click="resetForm('form')">取消</el-button>
            <!-- <el-button type="primary" @click="submitForm('form', '1')" v-if="sonList[0]?.is_draft == '1'">保存草稿</el-button> -->
          </el-col>
          <el-col :span="10">
            <el-button type="primary" @click="showConfirm">确定创建</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="创建子项目" :visible.sync="confirmShow" width="600px">
      <ul class="aul ulist" style="padding:0;" v-for="(item, index) in sonList" :key="index">
        <li>
          <span>子项目名称：</span>
          <span>{{ item.contract_name }}</span>
        </li>
        <li>
          <span>项目时间：</span>
          <span>{{ item.start_time }} - {{ item.end_time }}</span>
        </li>
      </ul>
      <ul class="aul ulist" style="padding:0;">
        <li><span style="margin: 0 auto; width: 70%;text-align: center;">注：确定创建后不能修改子项目信息</span></li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmShow = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form', '0')">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
import { timeFormat } from '@/utils/index.js'
export default {
  name: 'proSon',
  data() {
    return {
      nodeLimtList: [],
      isDraft: '',//用来判断当option为2时，从草稿变创建
      mType: '',
      form: {
        project_id: '',
        //合同信息
        contract_no: '',
        contract_name: '',
        contract_type: '',
        parent_project_id: '',
        contract_time: ['', ''],
        project_start_time_start_time: '',
        project_end_time: '',
        contract_amount: '',
        tax_rate: '6',
        tax: '',
        info: '',
        //项目信息-收款计划
        son_str: '',
        son_del: '',
      },
      sonList: [
        { contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', son_id: '', is_draft: '0', },
      ],
      del_son_list: [],
      rules: {

      },
      confirmShow: false,
    }
  },
  created() {
    this.query = this.$route.query
    this.mType = this.query.mType
    this.query.id && this.getDetail(this.query.id)
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    showConfirm() {
      if (!this.sonList[0].contract_name) {
        this.$message.error('请先添加子项目!')
        return false
      }
      if (!this.sonList[0].son_contract_time[0] || !this.sonList[0].son_contract_time[1]) {
        this.$message.error('请先添加子项目时间!')
        return false
      }
      this.confirmShow = true;
    },
    addSon(arr) {
      arr.push({
        contract_name: '',
        son_contract_time: [],
        start_time: '',
        end_time: '',
        is_draft: '0',
      });
    },
    removeSon(arr, index) {
      if (arr[index].payList && arr[index].payList.length > 0) {
        this.$message.error('请清空子项目支付计划后再进行操作!')
        return false
      }
      this.del_son_list.push(arr[index].id);
      console.log(this.del_son_list);
      arr = arr.splice(index, 1);
    },
    //子项目时间调整
    sonContractTime(index) {
      this.$forceUpdate()
      const time = this.sonList[index].son_contract_time
      this.sonList[index].start_time = this.fdate(time[0])
      this.sonList[index].end_time = this.fdate(time[1])
    },
    containsDuplicate(arr, key) {
      for (let k = 1; k < arr.length; k++) {
        if (arr[k][key] === arr[k - 1][key]) {
          return true;
        }
      }
      return false;
    },
    getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      this.$fly
        .post('ApiAdministrative_projectDetail.html', {
          id: id,
        })
        .then((res) => {
          let form = res.item_info
          delete form.is_apply
          res.son_list.length > 0 && (this.isDraft = res.son_list[0].is_draft)
          //修改0000-00-00错误显示1899年情况
          form.project_start_time = timeFormat(form.project_start_time)
          form.project_end_time = timeFormat(form.project_end_time)
          form.finish_time = timeFormat(form.finish_time)
          this.sonList = res.son_list.map((item) => {
            item.chosed = item.son_project_id > 0 ? true : false
            item.start_time = timeFormat(item.start_time)
            item.end_time = timeFormat(item.end_time)
            item.son_contract_time = []
            item.son_contract_time[0] = timeFormat(item.start_time)
            item.son_contract_time[1] = timeFormat(item.end_time)
            return item
          })
          //防空情况
          if (this.sonList.length === 0) {
            this.sonList = [{ contract_name: '', son_contract_time: ['', ''], start_time: '', end_time: '', son_id: '', is_draft: '0',}]
          }
          this.form = form
          console.log(this.form);
        })
    },
    submitForm(formName, is_draft = '1') {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateProject(is_draft)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateProject(is_draft = '1') {
      this.form.project_id = this.query.id || ''
      this.form.option = (this.sonList[0].id && this.sonList[0].id != '') ? '2' : '1'
      const flag = this.containsDuplicate(this.sonList, 'contract_name')
      if (flag) {
        this.$message.error('子项目名称不可重复')
        return false
      }
      // 替换掉id为son_id
      let $sonList = this.sonList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['son_id'] = item[key] || 0
            delete item[key]
          }
        })
        return item
      })
      $sonList = $sonList.map(({ contract_name, start_time, end_time, amount, son_id, is_draft }) => {
        return { contract_name, start_time, end_time, amount, son_id, is_draft }
      })
      if (is_draft == '1') {
        $sonList = $sonList.map((item) => {
          item.is_draft = '1'
          return item
        })
      } else if (is_draft == '0') {
        $sonList = $sonList.map((item) => {
          item.is_draft = '0'
          return item
        })
      }
      const tempForm = JSON.parse(JSON.stringify(this.form))
      this.$fly
        .post('ApiAdministrative_createOrUpdateSubProject.html', {
          ...tempForm,
          son_str: JSON.stringify($sonList),
          son_del: this.del_son_list.toString(),
          mType: this.mType,
          // is_creat: (this.form.option == '2' && this.isDraft != is_draft) ? '1' : '', 
          //isDraft为临时存储接收到的is_draft
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  //标题样式
  @extend %box;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  padding: 20px 40px;
  margin-bottom: 10px;
  @extend %center;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;

  .header-info {
    width: 80%;
    @extend %center;
    align-items: flex-start;
    text-align: left;

    h1 {
      font: 700 28px/1 $font;
      margin-bottom: 16px;
    }

    p {
      font: 16px/2 $font;
    }
  }

  .header-status {
    @extend %center;
    flex-flow: row nowrap;

    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
    }
  }
}

.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .ntitle {
      display: inline-block;
      margin: 0 0 25px 0;

      &::before {
        width: 100%;
      }
    }

    ul {
      @extend %start;
      color: #231f20;
      background: #f2f2f2;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }

          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }
        }
      }
    }

  }
}

.aul.ulist {
  min-height: 28px;
  padding: 20px 0;
  font: 14px/2 $font;
  text-align: left;

  >li {
    padding: 0 60px;
    display: flex;
    flex-flow: row nowrap;

    span {
      display: inline-block;
      
      &:nth-of-type(1) {
        width: 30%;
      }

      &:nth-of-type(2) {
        width: 70%;
      }
    }
  }
}
</style>